import { Box, Button, Group, Stack, TextInput, Tooltip } from "@mantine/core";
import { IconPlus, IconPrinter, IconTrash, IconTrashOff, IconX } from "@tabler/icons-react";
import React, { useRef, useState } from "react";
import ReactToPrint from "react-to-print";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import { setHideDeletedMeetingSeriesInRedux } from "../meetingSlice";
import { MeetingSeriesTable } from "./MeetingSeriesTable";
import NewMeetingSeriesModal from "./NewMeetingSeriesModal";

export const MeetingSeries: React.FC = () => {
  const [newMeetingSerieModalOpen, setNewMeetingSerieModalOpen] = useState<boolean>(false);
  const [search, setSearch] = useState("");
  const refContainer = useRef(null);

  const hideDeletedMeetingSeries = useAppSelector((state) => state.meetingReducer.hideDeletedMeetingSeries);

  const dispatch = useAppDispatch();
  return (
    <Stack h={"100%"} p={"xs"} gap={0}>
      <Box>
        <Group gap="xs" align="center" wrap="nowrap" w="100%" h={"49px"} mb={"xs"}>
          <Button
            leftSection={<IconPlus size={16} style={{ marginRight: "-4px" }} />}
            color="green"
            variant="filled"
            size="sm"
            onClick={() => setNewMeetingSerieModalOpen(true)}
          >
            Ny møteserie
          </Button>
          <TextInput
            placeholder="Søk…"
            value={search}
            onChange={(e) => setSearch(e.currentTarget.value)}
            size="sm"
            w={160}
            rightSection={
              search.length > 0 && (
                <Button variant="subtle" size="compact-xs" px={4} onClick={() => setSearch("")}>
                  <IconX size={14} />
                </Button>
              )
            }
          />
          <Box flex={1} />
          <Button
            variant="outline"
            size="sm"
            px="xs"
            color={hideDeletedMeetingSeries ? "warmgray.6" : "mc-primary"}
            bg={hideDeletedMeetingSeries ? "white" : "#e8eef4"}
            onClick={() => dispatch(setHideDeletedMeetingSeriesInRedux(!hideDeletedMeetingSeries))}
            rightSection={
              hideDeletedMeetingSeries ? (
                <IconTrash style={{ marginLeft: "-3px" }} />
              ) : (
                <IconTrashOff style={{ marginLeft: "-3px" }} />
              )
            }
          >
            {hideDeletedMeetingSeries ? "Vis slettede" : "Skjul slettede"}
          </Button>
          <ReactToPrint
            trigger={() => (
              <Tooltip label="Tabellutskrift" withArrow offset={2}>
                <Button color="mc-primary" px="sm" variant="light" size="sm">
                  <IconPrinter size={16} />
                </Button>
              </Tooltip>
            )}
            content={() => refContainer.current}
          />
        </Group>
      </Box>
      <NewMeetingSeriesModal opened={newMeetingSerieModalOpen} onClose={() => setNewMeetingSerieModalOpen(false)} />
      <Box ref={refContainer} style={{ flex: 1, overflow: "auto" }}>
        <MeetingSeriesTable search={search} />
      </Box>
    </Stack>
  );
};
